<app-header></app-header>

<ion-content scrollbar>
  <app-loading-sti *ngIf="loading"></app-loading-sti>
  <div *ngIf="!p.renderMobile" class="breadcrumb-margin margin-bottom-3">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ng-container *ngIf="!isError; else HTTPError">
    <ion-grid *ngIf="!loading">
      <ion-row class="margin-minus-20-mobile">
        <ion-col
          [attr.offset-xl]="userId ? '' : '3'"
          size-xl="6"
          size="12"
          class="high-z-index"
        >
          <app-card [title]="headerInit.title">
            <form [formGroup]="form" (ngSubmit)="Save()">
              <app-upload-attachment
                *ngIf="userId"
                [attachment]="user?.avatar"
                [user]="user"
                avatar="true"
              ></app-upload-attachment>

              <ion-label
                *ngIf="form.get('itemImage').hasError('fileMaxSize') && (form.get('itemImage').touched || validationError)"
                color="danger"
                class="font-size__16"
              >
                {{"ADD_COMPANY.MAX_SIZE"|translate}}
              </ion-label>

              <ion-label
                *ngIf="form.get('itemImage').hasError('fileFormat')"
                color="danger"
                class="font-size__16"
              >
                <div>
                  {{ "FILE_TYPE_VALIDATION_1" | translate }}
                  "{{form.get('itemImage').errors.fileFormat.actualFormat}}". {{
                  "FILE_TYPE_VALIDATION_2" | translate }}
                </div>
              </ion-label>

              <!-- EMAIL -->
              <app-input
                type="input"
                [form]="form"
                formControlName="email"
                [disabled]="userId"
                label="SETTINGS.EMAIL"
                [submittedError]="validationError"
              ></app-input>

              <!-- PASSWORD -->
              <ng-container *ngIf="!userId">
                <app-input
                  [type]="passwordEye ? 'text' : 'password'"
                  [form]="form"
                  formControlName="password"
                  label="USERS.PASSWORD"
                  [showPasswordEye]="true"
                  [(passwordEye)]="passwordEye"
                  [submittedError]="validationError"
                ></app-input>

              </ng-container>

              <!-- NAME -->
              <app-input
                type="input"
                [form]="form"
                formControlName="firstName"
                label="USERS.NAME"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="input"
                [form]="form"
                formControlName="lastName"
                label="USERS.SURNAME"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="input"
                [form]="form"
                formControlName="telephone"
                label="USERS.TELEPHONE"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="input"
                [form]="form"
                formControlName="mobilePhone"
                label="USERS.MOBILE"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="input"
                [form]="form"
                formControlName="carPlate"
                label="USERS.CAR_PLATE"
                [submittedError]="validationError"
              ></app-input>

              <div
                *appHasRole="['user.change-company']"
                class="control-display"
                [ngClass]="{'control-display--invalid': !form.get('company').valid && (form.get('company').touched || validationError)}"
              >
                <ion-label
                  >{{'ADD_COMPANY.COMPANY' | translate }}*
                  <ion-icon
                    *ngIf="userServ.userGroupDeparments?.length > 0"
                    src="../../../../assets/icons/info.svg"
                    (click)="onShowPopover($event)"
                    class="cursor-pointer"
                  ></ion-icon>
                </ion-label>

                <app-select-dropdown
                  [isDisabled]="userServ.userGroupDeparments?.length > 0"
                  formControlName="company"
                  [data]="companyServ.companies"
                  (touchEvent)="onSelectTouched('company')"
                  (changeValueEvent)="onChangeCompany($event)"
                ></app-select-dropdown>
              </div>

              <ion-label
                *ngIf="!form.get('company').valid && (form.get('company').touched || validationError)"
                color="danger"
                class="font-size__16"
              >
                {{"USERS.COMPANY_VALIDATION"|translate}}
              </ion-label>

              <!-- Uprawnienia -->
              <div
                class="control-display"
                *appHasRole="['user.change-company']"
                [ngClass]="{'control-display--invalid': !form.get('idRole').valid && (form.get('idRole').touched || validationError)}"
              >
                <ion-label>{{'USERS.ROLE' | translate }}*</ion-label>

                <app-select-dropdown
                  formControlName="idRole"
                  [data]="userServ.userRoles"
                  [value]="currentRole"
                  (touchEvent)="onSelectTouched('idRole')"
                ></app-select-dropdown>
              </div>
              <ion-label
                *ngIf="!form.get('idRole').valid && (form.get('idRole').touched || validationError)"
                color="danger"
                class="font-size__16"
              >
                {{"USERS.ROLE_VALIDATION"|translate}}
              </ion-label>
              <!-- Recepcja -->

              <app-checkbox
                *appHasRole="['user.edit.reception']"
                [form]="form"
                formControlName="reception"
                [slot]="'start'"
                [checked]="userId ? user.reception : 'false'"
                label="USERS.RECEPTION"
              ></app-checkbox>

              <app-checkbox
                *appHasRole="['user.edit.visibleInVirtualReception']"
                [form]="form"
                formControlName="visibleInVirtualReception"
                [slot]="'start'"
                [checked]="userId ? user.visibleInVirtualReception : 'false'"
                label="USERS.VISIBLE_VIRTUAL_RECEPTION"
              ></app-checkbox>

              <ng-container *ngIf="userId && !user.activated">
                <ion-item
                  *appHasRole="['user.edit.status']"
                  class="input ion-padding-bottom"
                  lines="none"
                >
                  <div>
                    <ion-label>
                      {{ "USERS.REQUIRES_ACTIVATION" | translate }}
                    </ion-label>
                    <app-select-buttons
                      [keyValueList]="dictionaryServ.dictionaryUserStatus"
                      [selectedValue]="user.activated"
                      formControlName="activated"
                      [disableDeselect]="true"
                      (selectedChange)="selectedActivationChange($event)"
                    >
                    </app-select-buttons>
                  </div>
                </ion-item>
              </ng-container>

              <ng-container *ngIf="userId && user.activated">
                <ion-item
                  *appHasRole="['user.edit.status']"
                  class="input ion-padding-bottom"
                  lines="none"
                >
                  <div class="control-display">
                    <app-select-buttons
                      [keyValueList]="dictionaryServ.dictionaryUserStatus"
                      [selectedValue]="user.status"
                      formControlName="status"
                      [disableDeselect]="true"
                      (selectedChange)="selectedStatusChange($event)"
                    >
                    </app-select-buttons>
                  </div>
                </ion-item>
              </ng-container>

              <ion-item *ngIf="errorMessage.length > 0" lines="none">
                <ion-label color="danger" class="font-size__16">
                  {{ errorMessage | translate }}
                </ion-label>
              </ion-item>

              <div class="display-flex ion-justify-content-between">
                <div>
                  <ng-container *ngIf="userId && !p.renderMobile">
                    <ion-button
                      fill="outline"
                      color="primary"
                      (click)="onDeleteUser()"
                      *appHasRole="['user.edit']"
                    >
                      {{ "DELETE" | translate }}
                    </ion-button>
                  </ng-container>
                </div>

                <div>
                  <ion-button
                    fill="solid"
                    color="secondary"
                    (click)="back()"
                    *ngIf="!p.renderMobile"
                  >
                    {{ "CANCEL" | translate }}
                  </ion-button>

                  <ion-button
                    type="submit"
                    *appHasRole="['user.edit']"
                    [disabled]="disableSaveButton"
                    class="button-margin-left"
                  >
                    <ng-container *ngIf="!disableSaveButton"
                      >{{'SAVE' | translate}}</ng-container
                    >
                    <ng-container *ngIf="disableSaveButton"
                      >{{'SAVING' | translate}}</ng-container
                    >
                  </ion-button>
                </div>
              </div>
            </form>
          </app-card>
        </ion-col>

        <ion-col size-xl="6" size="12" *ngIf="userId">
          <app-card
            title="{{ 'EDIT_COMPANY.DEPARTMENTS' | translate}}"
            hideHeaderBreakpoint="300"
          >
            <app-pagination-client-side
              [componentRef]="componentRef"
              styleClass="gray-md-rows"
              [columns]="departmentsColumns"
              [options]="options"
              (rowsLoaderReady)="rowsLoaderServiceReady($event)"
              (actionRequest)="handleActionRequest($event)"
              (headerEmitClick)="addDepartment()"
              (refreshRequest)="departmentRefresh()"
            >
            </app-pagination-client-side>
          </app-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="USERS.USER"
      link="app/users"
      returnText="USERS.RETURN_TO_USERS"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>
